import React from 'react';
import { AlertCircle } from 'lucide-react';
import Header from './Header';

interface ErrorDisplayProps {
    title?: string;
    message: string;
}

const ErrorDisplay: React.FC<ErrorDisplayProps> = ({ title = 'אופס! נתקלנו בבעיה', message }) => {
    return (
        <div className="min-h-screen bg-white flex flex-col">
            <Header />

            <main className="flex-grow flex flex-col items-center px-6 pt-12 pb-20 relative z-20">
                <div className="w-full max-w-xl bg-white border border-brand-gold/20 rounded-3xl p-8 sm:p-12 shadow-[0_20px_40px_rgba(19,52,55,0.05)] text-center animate-in fade-in zoom-in duration-500">
                    <div className="text-red-500 bg-red-50 w-20 h-20 rounded-full flex items-center justify-center mx-auto mb-4">
                        <AlertCircle className="w-10 h-10" />
                    </div>

                    <div>
                        <h2 className="text-2xl font-bold text-brand-dark font-serif mb-2">{title}</h2>

                        <div className="mt-4 flex flex-col items-center gap-2 bg-red-50 border border-red-100 p-4 rounded-2xl text-red-800 text-sm text-center">
                            <AlertCircle className="w-5 h-5 text-red-500" />
                            <div className="w-full">
                                {message}
                            </div>
                        </div>
                    </div>

                    <div className="mt-8 pt-6 border-t border-gray-100">
                        <a
                            href="https://karenavnam.com"
                            className="text-brand-gold font-bold hover:underline transition-all"
                        >
                            לבקר באתר של קארן אבנם
                        </a>
                    </div>
                </div>
            </main>
        </div>
    );
};

export default ErrorDisplay;
